import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import { deliveryAreaKeys } from './keys';

import type { TypeGetDeliveryTypeParams, TypeGetDeliveryTypeResponse } from '~/types/delivery-agency.types';

/**
 * [배송 권역] 화주사 배송 권역 조회 API
 */
const fetchGetDeliveryType = async (
  vendor: string,
  params: TypeGetDeliveryTypeParams
): Promise<TypeGetDeliveryTypeResponse['data']> => {
  const { data } = await axiosInstance.get<TypeGetDeliveryTypeResponse>(
    `${API_ENDPOINT.DELIVERY_AGENCY.GET_DELIVERY_TYPE}/${vendor}/delivery-type`,
    { params }
  );

  return data.data;
};

type UseGetDeliveryTypeQueryOptions = {
  vendor: string;
  params: TypeGetDeliveryTypeParams;
  enabled?: boolean;
};

export const useGetDeliveryTypeQuery = ({ vendor, params, enabled = true }: UseGetDeliveryTypeQueryOptions) => {
  return useQuery({
    queryKey: deliveryAreaKeys.deliveryType(vendor, params),
    queryFn: () => fetchGetDeliveryType(vendor, params),
    enabled,
    staleTime: 0,
    gcTime: 0,
    meta: { showGlobalErrorToast: false },
  });
};
